"use client";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
} from "@/components/ui/select";
import { useParams, usePathname, useRouter } from "next/navigation";

import { MdLanguage } from "react-icons/md";
import { localeNames, locales } from "@/i18n/locale";

import { cn } from "@/lib/utils";

export default function ({ isIcon = false, className }: { isIcon?: boolean; className?: string }) {
  const params = useParams();
  const locale = params.locale as string;
  const router = useRouter();
  const pathname = usePathname();

  const handleSwitchLanguage = (value: string) => {
    if (value !== locale) {
      let newPathName = pathname.replace(`/${locale}`, `/${value}`);
      if (!newPathName.startsWith(`/${value}`)) {
        newPathName = `/${value}${newPathName}`;
      }
      router.push(newPathName);
    }
  };

  return (
    <Select value={locale} onValueChange={handleSwitchLanguage}>
      <SelectTrigger className={cn("flex items-center gap-2 border-none text-muted-foreground outline-hidden hover:bg-transparent focus:ring-0 focus:ring-offset-0", className)}>
        <div className="flex items-center gap-2">
          <MdLanguage className="text-xl" />
          <span>{localeNames[locale]}</span>
        </div>
      </SelectTrigger>
      <SelectContent className="z-50 min-w-[140px] rounded-xl border border-[hsl(28,18%,24%,0.85)] bg-gradient-to-b from-[hsl(28,22%,14%,0.98)] to-[hsl(24,20%,10%,0.99)] shadow-[0_25px_60px_hsl(0,0%,0%,0.5)] backdrop-blur-xl">
        {locales.map((key) => {
          const name = localeNames[key] ?? key;
          return (
            <SelectItem
              className="cursor-pointer px-4 py-2.5 text-[hsl(36,40%,92%)] transition-all duration-200 hover:bg-[hsl(38,62%,56%,0.15)] focus:bg-[hsl(38,62%,56%,0.2)] focus:text-[hsl(40,75%,64%)] data-[state=checked]:text-[hsl(40,75%,64%)] data-[state=checked]:font-medium rounded-lg mx-1"
              key={key}
              value={key}
            >
              {name}
            </SelectItem>
          );
        })}
      </SelectContent>
    </Select>
  );
}
